import { openWeb } from '@g/utils/appSDK'

export const msgType = {
  alert: 'alert',
  confirm: 'confirm',
  noaction: 'noaction',
}

export const msgMap = {
  RcvrTransferInOrd: {
    type: msgType.alert,
    async handle (data) {
      window.vueApp.$confirm(`${data.rcvrNickname} 設定了僅接收來自淘寶/阿里巴巴導入的包裹。`, {
        title: '轉移失敗',
        theme: 'title-flat',
        buttonFalseText: false,
      })
    },
  },
  SendIntervalLimit: {
    type: msgType.alert,
    async handle (res) {
      window.vueApp.$confirm(res.data.message || 'SendIntervalLimit', {
        buttonFalseText: false,
      })
    },
  },
  NewDeviceNeedCellphoneCaptcha: {
    type: msgType.alert,
    async handle (res) {
      console.log('NewDeviceNeedCellphoneCaptcha', res)
      window.vueApp.$eventBus.$emit(window.vueApp.$eventType.NewDeviceNeedCellphoneCaptcha, {
        res,
      })
    },
  },
  UidExists: {
    type: 'noaction',
  },
  OidExists: {
    type: 'noaction',
  },
  RcvrEmpty: {
    type: 'noaction',
  },
  ErrorAppointorNickname: {
    type: 'noaction',
  },
  RcvrInput: {
    type: 'noaction',
  },
  UserError: {
    type: 'noaction',
  },
  RcvrSelves: {
    type: 'noaction',
  },
  PayPwdErrsLimit: {
    type: 'noaction',
  },
  password: {
    type: 'noaction',
  },
  LedgerBalanceLess: {
    type: 'noaction',
  },
  EGSSuda7DashEmpty: {
    type: 'noaction',
  },
  HCTStnoStopEmpty: {
    type: 'noaction',
  },
  ExtraInfoCarrierEmpty: {
    type: 'noaction',
  },
  CneeAddrDiscNoSupportCvs: {
    type: 'noaction',
  },
  TransactionException: {
    type: 'noaction',
  },
  newNickname: {
    type: 'noaction',
  },
  NicknameExists: {
    type: 'noaction',
  },
  baAcctNo: {
    type: 'noaction',
  },
  ValidateCaptchaIncorrect: {
    type: 'noaction',
  },
  CaptchaIncorrect: {
    type: 'noaction',
  },
  refUidKkr: {
    type: 'noaction',
  },
  CorpNameEmpty: {
    type: 'noaction',
  },
  DgCartQtyLimit: {
    type: 'noaction',
  },
  DG1688ItemExists: {
    type: 'noaction',
  },
  DG1688TaobaoItemExists: {
    type: 'noaction',
  },
  ItemWithAreasLimited: {
    type: msgType.alert,
    handle () {
      setTimeout(() => {
        window.vueApp.$confirm('賣家不支持配送至您所選的倉庫地址，請切換至其他倉庫地址後繼續下單。', {
          buttonFalseText: false,
        })
      }, 400)
    },
  },
  TradevanUnmatch: {
    type: msgType.confirm,
    async handle () {
      if (!await window.vueApp.$confirm('未完成易利委實名認證', {
        buttonTrueText: '重新填寫',
        buttonFalseText: '查看教學',
      })) {
        if (window.isPc) {
          window.vueApp.$store.dispatch('viewPost', '12352')
        } else {
          openWeb({ name: 'PostDetail', query: { poid: 12352 } })
        }
      }
    },
  },
  PreApntdProviderNonsupport: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('當前出貨渠道不支持預先委任，請於明日再試。為避免影響出貨時效，建議在EZWAY取消預先委任。', {
        buttonFalseText: false,
        buttonTrueText: '關閉預先委任教學',
      }).then(r => {
        if (r) {
          if (window.isPc) {
            window.vueApp.$store.dispatch('viewPost', '169117')
          } else {
            openWeb({ name: 'PostDetail', query: { poid: 169117 } })
          }
        }
      })
    },
  },
  PreApntd12101598Nonsupport: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('當前委任報關行無支持預先委任，請更換申報人或待更換報關業者後再下單', {
        buttonFalseText: false,
      })
    },
  },
  PreApntdAirNonsupport: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('空運不支持預先委任，請關閉預先委任後隔天重試', {
        buttonFalseText: false,
        buttonTrueText: '關閉預先委任教學',
      }).then(r => {
        if (r) {
          if (window.isPc) {
            window.vueApp.$store.dispatch('viewPost', '169117')
          } else {
            openWeb({ name: 'PostDetail', query: { poid: 169117 } })
          }
        }
      })
    },
  },
  PayPwdEmpty: {
    type: msgType.alert,
    handle (res) {
      if (window.isPc) {
        this.$toast('請先設置錢包密碼')
        this.$router.push({ name: 'WalletSetPayPwd' })
      } else {
        this.$toast('請先設置錢包密碼')
        window.vueApp.$eventBus.$emit(window.vueApp.$eventType.OpenSetPayPwdDialog)
      }
    },
  },
  PclidsOrdered: {
    type: msgType.alert,
    handle (res) {
      if (window.isPc) {
        window.vueApp.$store.commit('order/setShowOrderDialogData', {
          oid: res.data.extras.oid,
        })
      } else {
        window.vueApp.$router.replace({ name: 'KkrenOrderDetail', query: { oid: res.data.extras.oid } })
      }
    },
  },
  PreApntdWhseNonsupport: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('該倉庫不支持預先委任，請關閉預先委任後隔天重試', {
        buttonFalseText: false,
        buttonTrueText: '關閉預先委任教學',
      }).then(r => {
        if (r) {
          if (window.isPc) {
            window.vueApp.$store.dispatch('viewPost', '169117')
          } else {
            openWeb({ name: 'PostDetail', query: { poid: 169117 } })
          }
        }
      })
    },
  },
  VaorderUnpaidTvIdNum: {
    type: msgType.alert,
    handle (res) {
      const tips = `此申報人已被其他用戶 ${res.data.extras.vaUid || ''} 使用，且有未繳清費用，需登入該帳號繳清費用後才可繼續使用此申報人。`

      window.vueApp.$confirm(tips, {
        buttonFalseText: false,
      })
    },
  },
  CnorderOidExist: {
    type: msgType.alert,
    handle (res) {
      if (window.isPc) {
        // window.vueApp.$store.dispatch('viewPost', '169117')
        window.vueApp.$router.push({
          name: 'Order',
          query: {
            cnoid: res.data.extras.cnoid
          },
        })
      } else {
        window.vueApp.$router.push({
          name: 'KkrenOrderCnorderDetail',
          query: {
            cnoid: res.data.extras.cnoid
          },
        })
      }
    },
  },
  SuspendSpliceUser: {
    type: msgType.alert,
    handle (res) {
      let tips = '由於您被其他會員多次檢舉巧拼接單後不回覆，已永久限制巧拼功能使用，不影響使用其他功能。'
      if (res && res.data.extras && res.data.extras.tips) {
        tips = res.data.extras.tips
      }
      window.vueApp.$confirm(tips, {
        buttonFalseText: false,
      })
    },
  },
  ExistUnpublishPost: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('您已分享過連結，無須重複提供^^', {
        buttonFalseText: false,
      })
    },
  },
  CvsStoCodeMissing: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('門市已關閉，請另選其他門市', {
        buttonFalseText: false,
      })
    },
  },
  ParcelTmpLimit: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('由於海關政策有重大調整，系統升級中，暫時無法下單打包，預計今天完成升級。今天下單和明天下單都是週一到港，不會影響船期，請勿擔心。', {
        buttonFalseText: false
      })
    },
  },
  EmptyItems: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('這波抽盲盒已結束，不要問，不強求，緣份到了自然能再抽獎', {
        buttonFalseText: false,
      })
    },
  },
  UserViewTaobaoDailyLimit: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('查詢次數過於頻繁，請稍後再試。', {
        buttonFalseText: false,
      })
    },
  },
  VisitTimesError: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('查詢次數過於頻繁，請稍後再試。', {
        buttonFalseText: false,
      })
    },
  },
  CodeUnExist: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('激活碼錯誤', {
        buttonFalseText: false,
      })
    },
  },
  EXPECoinAmountNotEnough: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('金巧幣不足', {
        buttonFalseText: false,
      })
    },
  },
  AddressInvalid2: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('該收件人、申報人曾謊報品名衝關，已被停止使用，如有疑問請與客服聯絡。', {
        buttonFalseText: false,
      })
    },
  },
  NewPorStatusInvalid: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('T幣已儲值成功，請重整畫面後查看', {
        buttonFalseText: false,
      })
    },
  },
  DailyVisitorLimitTpttSearch: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('今日查詢次數已經用盡，提升力量值可以增加次數。', {
        buttonFalseText: false,
      })
    },
  },
  CvsStoCloseTime: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('門市已關閉，請另選其他門市收件', {
        buttonFalseText: false,
      })
    },
  },
  target: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('驗證發送過於頻繁，請於1分鐘後重試', {
        buttonFalseText: false,
      })
    },
  },
  NotRelParcel: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('您關聯的包裹單號並非同一組單號，請手動登記', {
        buttonFalseText: false,
      })
    },
  },
  ParcelOidCannotDelete: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('子母件已關聯包裹集運，品名無法修改，如有其他問題請聯絡客服', {
        buttonFalseText: false,
      })
    },
  },
  RegionNotAllowed: {
    type: msgType.alert,
    handle (res) {
      window.vueApp.$confirm(`禁止台灣以外IP登入<br/>您的IP是${res.data.extras.ip}`, {
        buttonFalseText: false,
      })
    },
  },
  JyorderStatusPacking: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('打包過程中託運單已列印完成，現場打包員較多，逐一詢問會打擾中斷打包組整體的工作進度，因此無法在打包中修改收件地址。', {
        buttonFalseText: false,
      })
    },
  },
  IpTwLimitCanMailSea: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('僅限台灣 IP 使用', {
        buttonFalseText: false,
      })
    },
  },
  JyorderStatusIllegal: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('訂單已經開始揀貨打包，不能取消訂單。', {
        buttonFalseText: false,
      })
    },
  },
  ParcelBlindboxError: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('包裹超過倉儲期限，已被倉庫清理或銷毀', {
        buttonFalseText: false,
      })
    },
  },
  BankAcctLimit: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('單一會員帳號最多只能新增10組銀行帳戶，若您想要再繼續新增，請先刪除其他已登記的銀行帳戶後再試一次', {
        buttonFalseText: false,
      })
    },
  },
  ParcelBlindboxDestroyed: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('包裹超過倉儲期限，已被倉庫清理或銷毀', {
        buttonFalseText: false,
      })
    },
  },
  PreorderExistsUnpaid: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('您上一筆儲值訂單尚未付款，請先處理。', {
        buttonFalseText: false,
      })
    },
  },
  MxDgorderAwaitingPayment: {
    type: msgType.alert,
    handle (res) {
      window.vueApp.$confirm('您有一筆訂單尚末完成付款<br>請先完成支付再申請下一筆代購', {
        title: '當前存在未付款訂單',
        buttonFalseText: false,
        buttonTrueText: '立即查看',
        contentClass: 'text-center',
        color: 'success',
        icon: '',
        theme: 'title-flat'
      }).then(r => {
        if (r) {
          window.vueApp.$router.push({
            name: 'MxdgDetail',
            params: {
              id: String(res.data.extras.dgid)
            },
          })
        }
      })
    },
  },
  vaorderPayDelay: {
    type: msgType.alert,
    handle () {
      window.vueApp.$confirm('您有一筆訂單尚末完成付款，請先付款後再繼續其他操作。', {
        buttonFalseText: false,
        buttonTrueText: '現在去支付',
      }).then(r => {
        if (r) {
          if (window.isPc) {
            window.vueApp.$router.push({
              name: 'Order',
              query: {
                tabIndex: 'vaorder'
              }
            })
          } else {
            window.vueApp.$router.push({
              name: 'KkrenOrder',
              query: {
                tabIndex: 'vaorder'
              }
            })
          }
        }
      })
    },
  },
}

export function getMsg (code, vals) {
  return msgMap[code].msg.replace(/\$(\d+)/g, (match, p1) => vals[p1 - 1] || '')
}
